const RapsoDocumentTabV2 = () =>
  import(
    /* webpackChunkName: "RapsoDocumentTabV2" */ `@/components/rapsotec/projects/project/NewDocument/RapsoDocumentTabV2.vue`
  );

const DocumentAiClassificationTab = () =>
  import(
    /* webpackChunkName: "DocumentAiClassificationTab" */ `@/components/rapsotec/projects/project/NewDocument/DocumentAiClassificationTab.vue`
  );

const ConceptionDocumentTab = () =>
  import(
    /* webpackChunkName: "ConceptionDocumentTab" */ `@/components/rapsotec/projects/project/NewDocument/ConceptionDocumentTab.vue`
  );

const ExecutionWithoutFormalTopicTab = () =>
  import(
    /* webpackChunkName: "ExecutionWithoutFormalTopicTab" */ `@/components/rapsotec/projects/project/NewDocument/ExecutionWithoutFormalTopicTab.vue`
  );

const ImportantDocumentTab = () =>
  import(
    /* webpackChunkName: "ImportantDocumentTab" */ `@/components/rapsotec/projects/project/NewDocument/ImportantDocumentTab.vue`
  );

const PhotographyDocumentTab = () =>
  import(
    /* webpackChunkName: "PhotographyDocumentTab" */ `@/components/rapsotec/projects/project/NewDocument/PhotographyDocumentTab.vue`
  );

const SediTabV2 = () =>
  import(
    /* webpackChunkName: "SediTabV2" */ `@/components/rapsotec/projects/project/NewDocument/SediTabV2.vue`
  );

const GeneratedReportsTab = () =>
  import(
    /* webpackChunkName: "GeneratedReportsTab" */ `@/components/rapsotec/projects/project/NewDocument/GeneratedReportsTab.vue`
  );

const SediWithoutFormalTopicTab = () =>
  import(
    /* webpackChunkName: "SediWithoutFormalTopicTab" */ `@/components/rapsotec/projects/project/NewDocument/SediWithoutFormalTopicTab.vue`
  );

const AdminContratDocumentTab = () =>
  import(
    /* webpackChunkName: "AdminContratDocumentTab" */ `@/components/rapsotec/projects/project/NewDocument/AdminContratDocumentTab.vue`
  );

const bim360TabV2 = () =>
  import(
    /* webpackChunkName: "bim360Tab" */ `@/components/rapsotec/projects/project/NewDocument/Bim360TabV2.vue`
  );

export default [
  {
    path: "",
    name: "projectDocumentV2",
    component: RapsoDocumentTabV2,
  },
  {
    path: "ai-classification",
    name: "documentAiClassificationGed",
    component: DocumentAiClassificationTab,
  },
  {
    path: "conception",
    name: "conceptionDocumentV2",
    component: ConceptionDocumentTab,
  },
  {
    path: "execution-without-formal-topic",
    name: "executionWithoutFormalTopicV2",
    component: ExecutionWithoutFormalTopicTab,
  },
  {
    path: "important",
    name: "importantDocumentV2",
    component: ImportantDocumentTab,
  },
  {
    path: "photographies",
    name: "projectPhotographyDocumentV2",
    component: PhotographyDocumentTab,
  },
  {
    path: "sedi",
    name: "projectDocumentSediV2",
    component: SediTabV2,
  },
  {
    path: "bim360",
    name: "bim360TabV2",
    component: bim360TabV2,
  },
  {
    path: "generated-reports",
    name: "projectGeneratedReportsV2",
    component: GeneratedReportsTab,
  },
  {
    path: "sedi-without-formal-topic",
    name: "sediWithoutFormalTopicV2",
    component: SediWithoutFormalTopicTab,
  },
  {
    path: "admin-contrat",
    name: "adminContratDocumentV2",
    component: AdminContratDocumentTab,
  },
];
